<template>
  <div class="dialog">
    <div class="dialog__container">
      <div class="dialog__header bg--primary">
        <h2 class="header__title txt--white pt--1 pl--2 pr--2 pb--1 mb--0">
          <slot name="title"></slot>
        </h2>
      </div>
      <div class="dialog__body">
        <div class="pt--2 pl--2 pr--2 pb--2">
          <slot name="body"></slot>
        </div>
      </div>
      <div class="diaglog__actions bg--primary pt--2 pl--2 pr--2 pb--2">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/modules/dialog.scss";
</style>
